function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Event } from "@churchofjesuschrist/eden-icons";
import Input from "./Input";
import { internalUseOnlyOpenDetailsStyles } from "./sharedCss";
import { ValidityStateContext } from "./validityState";
import { spacing32 } from "@churchofjesuschrist/eden-style-constants";
const InputExtended = styled(Input).withConfig({
  componentId: "sc-1oyxgsq-0"
})(["", ";position:relative;&::-webkit-calendar-picker-indicator{position:absolute;top:0;right:0;bottom:0;width:", ";height:auto;color:transparent;background:transparent;}&::-webkit-inner-spin-button{z-index:1;}&::-webkit-clear-button{z-index:1;}"], internalUseOnlyOpenDetailsStyles({
  Icon: Event
}), spacing32);

/**
 * The DateInput allows a user to select a date.
 */
const DateInput = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    validityState,
    small,
    name,
    min,
    max,
    required,
    value,
    onChange,
    onValid,
    defaultValue,
    autoComplete,
    ...props
  } = _ref;
  const validityStateContext = useContext(ValidityStateContext);
  if (onValid) {
    const isValid = /[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(value);
    if (isValid) {
      onValid(value);
    }
  }
  return /*#__PURE__*/React.createElement(InputExtended, _extends({
    validityState: validityState ? validityState : validityStateContext,
    small,
    name,
    min,
    max,
    required,
    value,
    onChange,
    defaultValue,
    autoComplete,
    ref
  }, props, {
    type: "date"
    // Fallbacks used when the native date type is not available
    ,
    pattern: "[0-9]{4}-[0-9]{2}-[0-9]{2}",
    placeholder: "YYYY-MM-DD"
  }));
});
DateInput.displayName = "DateInput";
DateInput.propTypes = {
  /** Used to reference the input in JavaScript, or to reference form data after a form is submitted */
  name: PropTypes.string,
  /** A valid full-date as defined in RFC 3339 (`YYYY-MM-DD`) */
  value: PropTypes.string,
  /** Callback to execute when the value changes */
  onChange: PropTypes.func,
  /** Callback to execute when the value is a valid full-date as defined in RFC 3339 (`YYYY-MM-DD`) */
  onValid: PropTypes.func,
  /** The current validity state of the Input */
  validityState: PropTypes.oneOf(["error", "warning", "success", "unknown"]),
  /** Whether the input is required to be filled out to validate */
  required: PropTypes.bool,
  /** A boolean indicating if the Input should be rendered in a smaller height */
  small: PropTypes.bool,
  /** The earliest date to accept as defined in RFC 3339 (`YYYY-MM-DD`) */
  min: PropTypes.string,
  /** The latest date to accept as defined in RFC 3339 (`YYYY-MM-DD`) */
  max: PropTypes.string,
  /** Default value for uncontrolled use */
  defaultValue: PropTypes.string,
  /** Specify what if any permission the user agent has to provide automated assistance [docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) */
  autoComplete: PropTypes.string
};
export default DateInput;